<template>
  <v-container fluid>
    <h2 class="display-1 font-weight-light">Available plans</h2>
    <iceverg-plans :current-plan="userData.plan"></iceverg-plans>
  </v-container>
</template>

<script>
  import icevergPlans from "../../components/Widgets/icevergPlans";

  export default {
    components: {icevergPlans},
    name: "IcevergPlans",
    data: () => ({}),
    computed: {
      userData() {
        return this.$store.getters.getUserFromToken;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plans/IcevergPlans.vue